import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Countdown from 'react-countdown-now';
import cloneDeep from 'lodash/cloneDeep';
import { WINDCREEK_LEGACY_URL } from 'utils/constants';
import { padNumber } from 'utils/functions';
import './DrawingDrumAlert.css';

const LATENCY_PENALTY_MS = 1000;
const EXPIRATION_EXT_MS = 2000;

class DrawingDrumAlert extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alert: null,
      alertDismissed: true
    };

    this.handleDismiss = this.handleDismiss.bind(this);

    this.expirationTimer = null;
  }

  componentWillUnmount() {
    this.clearExpirationTimer();
  }

  componentWillReceiveProps(nextProps) {
    // When the subscription updates the drum data, display any new alerts
    const next = nextProps.drumData.data;
    const current = this.state.alert;
    if (
      next &&
      next.notificationType === 'PENDING_WINNER' &&
      !alertsEqual(next, current)
    ) {
      const alert = cloneDeep(next);
      const timeLimitMs = alert.pendingExpiryMinutes * 60000;
      // Note: Until/unless we do server-client time sync, start the expiration
      // timer from when we receive the message.
      alert.expires = Date.now() + timeLimitMs - LATENCY_PENALTY_MS;
      this.setState({ alert: alert, alertDismissed: false });
      this.startExpirationTimer(alert.expires - Date.now() + EXPIRATION_EXT_MS);
    }
  }

  clearExpirationTimer() {
    if (this.expirationTimer) {
      clearTimeout(this.expirationTimer);
      this.expirationTimer = null;
    }
  }

  startExpirationTimer(duration) {
    this.clearExpirationTimer();
    this.expirationTimer = setTimeout(this.handleDismiss, duration);
  }

  handleDismiss() {
    this.clearExpirationTimer();
    if (!this.state.alertDismissed) {
      this.setState({ alertDismissed: true });
    }
  }

  render() {
    const { alert, alertDismissed } = this.state;

    if (!alert || alertDismissed) {
      return null;
    }

    return (
      <div className="draw-drum-container">
        <div className="alert-modal">
          <div className="alert-body">
            <div className="alert-title">Congratulations!</div>
            <div className="alert-message">{alert.message}</div>
            <div className="alert-countdown">
              {alert.expires > 0 && (
                <Countdown date={alert.expires} renderer={countdownRenderer} />
              )}
            </div>
          </div>
          <a
            href={`${WINDCREEK_LEGACY_URL}/drawings/${alert.drawId}`}
            target="_blank"
            className="alert-confirm btn btn-success"
            onClick={this.handleDismiss}
          >
            View Drawing
          </a>
          <button className="alert-dismiss btn" onClick={this.handleDismiss}>
            X
          </button>
        </div>
      </div>
    );
  }
}

function alertsEqual(a, b) {
  if (!a || !b) {
    return a === b;
  }
  return (
    a.timestamp === b.timestamp &&
    a.pendingExpiryMinutes === b.pendingExpiryMinutes &&
    a.drawId === b.drawId &&
    a.ticketId === b.ticketId &&
    a.prizeId === b.prizeId
  );
}

function countdownRenderer({ minutes, seconds }) {
  const setClass = !minutes && seconds < 20 ? 'expiring' : '';
  return (
    <span className={setClass}>
      Countdown: {padNumber(minutes)}:{padNumber(seconds)}
    </span>
  );
}

const SUBSCRIPTION_DRAWING_UPDATES = gql`
  subscription MyDrumUpdates {
    drumUpdates {
      notificationType
      prizeId
      ticketId
      drawId
      message
      pendingExpiryMinutes
      timestamp
    }
  }
`;

const withData = graphql(SUBSCRIPTION_DRAWING_UPDATES, {
  name: 'drumData'
});

export default withData(DrawingDrumAlert);



// WEBPACK FOOTER //
// ./src/containers/DrawingDrumAlert/index.js